// import axios from 'axios';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Newsletter from '../components/Newsletter';
import { mobile } from '../responsive';
// import { publicRequest } from '../requestMethods';
// import { addProducts } from '../redux/cartRedux';
// import { useDispatch } from 'react-redux';

const Container = styled.div`
   
`
const Wrapper = styled.div`
    margin-top: 60px;
    display: flex;
    background-color: aliceblue;
    ${mobile({ flexDirection: "column" })}
`
const ImgContainer = styled.div`
    flex: 1;
    max-width: 500px;
    display: grid;
    place-items: center;
`
const Image = styled.img`
   width: 100%;
`
const InfoContainer = styled.div`
   flex: 1;
   padding: 30px;
`
const Title = styled.h1`
   margin-bottom:10px ;
`
const Disc = styled.p`
   letter-spacing: 1px;
   font-size: 18px;
`
const Price = styled.h3`
   font-size: 50px;
   font-weight: 700;
   margin: 10px 0;
`
const FiterContainer = styled.div`
     display: flex;
     justify-content: space-between;
     margin: 10px 0;
     width: 50%;
     ${mobile({ width: "100%" })}
`
const Filter = styled.div`
    flex: 1;   
    display: flex;
    align-items: center;
`
const FilterTitle = styled.span`
    font-size: 20px;
    font-weight: 200;
`
const FilterColor = styled.div`
     width: 20px;
     height: 20px;
     border-radius: 50%;
     background-color: ${props => props.color};
     margin: 0 5px;
     cursor: pointer;
`
const FilterSize = styled.select`
    flex: 1;
    padding: 10px;
    margin-left:10px ;
    display: flex;
    align-items: center;
    cursor: pointer;
    
`
const FilterSizeOption = styled.option`
   
`
const AddContainer = styled.div`
    display: flex;
    width: 50%;
    align-items: center ;
    justify-content: space-between;
    margin: 20px 0;
    ${mobile({ width: "100%" })}
`
const AmountContainer = styled.div`
    display: flex;  
    font-weight: 700;
    align-items: center ;
`
const Remove = styled.div`
    font-size: 20px;
    cursor: pointer;
`
const Amount = styled.div`
    display: flex;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    font-weight: 700;
    align-items: center;
    border: 1px solid teal;
    justify-content: center;
    margin: 0 10px;
`
const Add = styled.div`
    font-size: 20px;
    cursor: pointer;
`
const Button = styled.button`
    border: 1px solid teal;
    color: teal;
    background-color: transparent;
    padding: 10px;
    cursor: pointer;
&:hover{
    background-color: teal;
    border: none;
    color: #fff;
}
`



const SingleProduct = () => {
    // const location = useLocation();
    // const id = location.pathname.split("/")[2];

    // const [product, setProduct] = useState({});
    const [quantity,setQuantity] = useState(1);
    const [color,setColor] = useState(null);
    const [size,setSize] = useState(null);
    // const dispatch = useDispatch()

    // useEffect(() => {
    //     const getProduct = async () => {
    //         try {
    //             const res = await publicRequest.get("http://localhost:5000/api/products/find/" + id);
    //             setProduct(res.data)
    //             // console.log(res)
    //            }catch(err){
    //                 console.log(err)
    //             }
    //         }
    //       getProduct();
    //     },[id])
       const handleQuantity =(type) =>{
            if(type==="incre"){
               setQuantity(quantity+1)
            }else if(type==="dec"){
                (quantity===1) ? setQuantity(1): setQuantity(quantity-1);
            }
        }
    //    const handleClick=()=>{
    //     dispatch(addProducts({...product,quantity,color,size}))         
    //    }
      
       return (
        <>
            <Container >
                <Navbar/>
                <Wrapper >
                    <ImgContainer>
                        <Image src="https://static.zajo.net/content/mediagallery/zajo_dcat/image/product/types/X/9088.png" />
                    </ImgContainer>
                    <InfoContainer>
                        <Title>T-shirt For Men</Title>
                        <Disc>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta veritatis sit perferendis fuga consectetur asperiores repellat dolorem excepturi vero ipsum recusandae dolores optio officia ad unde doloribus, magni commodi porro doloremque? Temporibus repellat incidunt excepturi laborum enim asperiores consequuntur soluta.</Disc>
                        <Price> $ 349</Price>
                        <FiterContainer>
                            <Filter>
                                <FilterTitle>Color</FilterTitle>
                                <FilterColor color="red" onClick={()=>setColor()}/>
                                <FilterColor color="yellow" onClick={()=>setColor()}/>
                                <FilterColor color="green" onClick={()=>setColor()}/>
                               
                            </Filter>
                            <Filter>
                                <FilterTitle>Size</FilterTitle>
                                <FilterSize onChange={(e)=>setSize(e.target.value)}>
                                <FilterSizeOption >S</FilterSizeOption>
                                <FilterSizeOption >M</FilterSizeOption>
                                <FilterSizeOption >XL</FilterSizeOption>
                                <FilterSizeOption >XXL</FilterSizeOption>
                                <FilterSizeOption >S</FilterSizeOption>
                                
                                </FilterSize>
                            </Filter>
                        </FiterContainer>
                        <AddContainer >
                            <AmountContainer >
                                <Remove onClick={()=>handleQuantity("dec")}>-</Remove>
                                <Amount>{quantity}</Amount>
                                <Add onClick={()=>handleQuantity("incre")}>+</Add>
                            </AmountContainer>
                            <Button>ADD TO CART</Button>
                        </AddContainer>
                    </InfoContainer>
                </Wrapper>
                <Newsletter/>
                <Footer/>
            </Container>
        </>
    )
}

export default SingleProduct;